import React from "react";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import Typography from "@mui/material/Typography";
import moment from "moment";
import TimelineDot from "@mui/lab/TimelineDot";
import PropTypes from "prop-types";
import {
  GROUP_BY_SURVEY,
  GROUP_BY_TIME,
  GROUP_OPTIONS,
} from "./importTimeline";
import useClasses from "../useClasses";

const oppositeContentWidth = 70;
const timelineSeparatorWidth = 47;

const styles = (theme) => ({
  oppositeContent: {
    minWidth: oppositeContentWidth,
    maxWidth: oppositeContentWidth,
    padding: theme.spacing(1, 1),
    paddingBottom: theme.spacing(2),
    flex: 0,
  },
  cTimelineContent: {
    paddingTop: theme.spacing(0),
    paddingLeft: "8px",
  },
  date: {
    /*     display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 40,
    minHeight: 40, */
    width: "max-content",
    padding: 2,
    //textTransform: "uppercase",
  },
  cTimeLineDot: {
    marginBottom: "0px",
    marginTop: "0px",
    borderRadius: theme.shape.borderRadius,
    alignSelf: "center",
    //backgroundColor: theme.palette.primary.main,
    //color: theme.palette.common.white,
    backgroundColor: theme.palette.items.date,
    color: theme.palette.text.date,
    border: "none",
    boxShadow: "none",
  },
  cTimelineSeparator: {
    maxWidth: timelineSeparatorWidth,
    minWidth: timelineSeparatorWidth,
  },
  hide: {
    display: "none",
  },
  month: {
    color: theme.palette.text.secondary,
    marginLeft: -theme.spacing(1),
    //padding: "4px",
  },
});

function DateItem({ event, filterOnView }) {
  const classes = useClasses(styles);
  const year = moment().isSame(event.time, "year")
    ? ""
    : moment.utc(event.time).format("YYYY");

  const groupOption = {
    first: "",
    second: "",
    third: `${moment.utc(event.time).format("MMM")} ${year}`,
    fourth: "",
  };

  if (filterOnView === GROUP_BY_TIME) return null;
  return (
    <TimelineItem>
      <TimelineOppositeContent className={classes.oppositeContent}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "left",
          }}
        >
          <Typography
            variant="h6"
            color="textSecondary"
            className={classes.date}
            style={{ lineHeight: 1 }}
          >
            {groupOption.first} {/* WED */}
          </Typography>
          <Typography
            variant="body2"
            color="textSecondary"
            className={classes.date}
            style={{ lineHeight: "1" }}
          >
            {groupOption.second} {/* DEC */}
          </Typography>
        </div>
      </TimelineOppositeContent>
      <TimelineSeparator className={classes.cTimelineSeparator}>
        <TimelineDot color="inherit" className={classes.cTimeLineDot}>
          <Typography
            variant="h6"
            color="inherit"
            className={classes.date}
            style={{ fontWeight: 400 }}
          >
            {groupOption.third} {/* 16 */}
          </Typography>
        </TimelineDot>
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent className={classes.cTimelineContent}>
        {groupOption.fourth} {/* Title */}
      </TimelineContent>
    </TimelineItem>
  );
}

DateItem.propTypes = {
  event: PropTypes.object.isRequired,
  filterOnView: PropTypes.oneOf(GROUP_OPTIONS),
};

export default DateItem;
